import { Instance } from 'mobx-state-tree';
import React from 'react';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spinner, VirtualTableHeaderItem } from '..';
import {
  GenericModelWithCRUDType,
  IPaginationFilter,
  modelWithCRUD,
} from '../../stores/utils/modelWithCRUD';
import { useFilterFetch } from '../../stores/utils/useFilterFetch';

import { ITableProps, Table } from './Table';

export interface IFetchedTableProps extends ITableProps {
  header?: VirtualTableHeaderItem[];
  store: Instance<ReturnType<typeof modelWithCRUD>>;
  itemModel: GenericModelWithCRUDType;
  emptyPlaceholder?: ReactNode;
  renderRow: (item: any) => ReactNode;
  filter?: IPaginationFilter<any>;
}

export const FetchedTable: React.FC<IFetchedTableProps> = ({
  header,
  store,
  itemModel,
  emptyPlaceholder,
  renderRow,
  filter: defaultFilter,
  ...tableProps
}) => {
  const { items, fetchMore } = useFilterFetch<typeof itemModel>(
    store,
    defaultFilter
  );

  if (!items) {
    return <Spinner size={16} />;
  }
  if (items.length === 0) {
    return emptyPlaceholder ? (
      <>{emptyPlaceholder}</>
    ) : (
      <FormattedMessage defaultMessage="No items found" />
    );
  }
  return (
    <Table
      {...tableProps}
      onScrollNearBottom={() => {
        fetchMore();
        tableProps.onScrollNearBottom && tableProps.onScrollNearBottom();
      }}
    >
      {header && (
        <thead>
          <tr>
            {header.map((item, i) => (
              <th key={i} style={{ width: item.width }}>
                {item.title}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {items.map((item) => (
          <React.Fragment key={item.id}>{renderRow(item)}</React.Fragment>
        ))}
      </tbody>
    </Table>
  );
};
